import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { Box, Button, Form, Icon, Stack, styled, Text, TextInput } from 'shell/components';

const CourseInformationInputs = ({ loading, form, errors, handleChange, handlePrev, handleComplete }) => {
    const { device } = useViewport();
    const { t } = useTranslation('auth');

    return (
        <RootBox device={device}>
            <Stack sx={{ mb: 6 }} alignItems={'center'} spacing={1}>
                <Text component={'h1'} variant={'h6'} weight={'medium'}>
                    {t('sign-up.create-course', 'Create a course')}
                </Text>
                <Text variant={'p1'} align={'center'}>
                    {t('sign-up.create-course-description', 'Please enter the name of your course')}
                </Text>
            </Stack>
            <Form onSubmit={handleComplete}>
                <InputStack spacing={4}>
                    <TextInput
                        error={Boolean(errors.courseName)}
                        helperText={errors.courseName}
                        label={t('sign-up.course-name-label', 'Course Name')}
                        placeholder={t('sign-up.course-name-placeholder', 'Enter course name')}
                        required
                        value={form.courseName}
                        onChange={(e) => handleChange('courseName', e.target.value)}
                    />
                </InputStack>
                <ButtonStack direction={'row'} justifyContent={'space-between'}>
                    <Button
                        color={'neutral'}
                        startIcon={<Icon kind={'arrowLeft'} />}
                        variant={'tertiary'}
                        onClick={handlePrev}
                    >
                        {t('common:controls.back', 'Back')}
                    </Button>
                    <Button loading={loading} type={'submit'}>
                        {t('sign-up.complete-setup', 'Complete Setup')}
                    </Button>
                </ButtonStack>
            </Form>
        </RootBox>
    );
};

const RootBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: device === 'mobile' ? 0 : theme.spacing(7),
        width: device === 'mobile' ? '100%' : 450,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '12px',
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

const ButtonStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 3, 0),
    };
});

export default CourseInformationInputs;
